import React, { useEffect, useState } from 'react';

const Field = ({ label, children }) => (
    <label className="account-details-field">
        <span>{label}</span>
        {children}
    </label>
);

const AccountDetails = ({ userData, handleProfileEdit }) => {
    const [editMode, setEditMode] = useState(false);
    const [formState, setFormState] = useState({
        first_name: '',
        last_name: '',
        email: '',
        username: '',
        password: '',
        confirm_password: '',
    });
    const [error, setError] = useState('');

    useEffect(() => {
        setFormState({
            first_name: userData.first_name || '',
            last_name: userData.last_name || '',
            email: userData.email || '',
            username: userData.username || '',
            password: '',
            confirm_password: '',
        });
    }, [userData]);

    const handleChange = (field, value) => {
        setFormState({ ...formState, [field]: value });
    };

    const handleCancel = () => {
        setEditMode(false);
        setError('');
        setFormState({
            first_name: userData.first_name || '',
            last_name: userData.last_name || '',
            email: userData.email || '',
            username: userData.username || '',
            password: '',
            confirm_password: '',
        });
    };

    const handleSave = async () => {
        setError('');
        if (formState.password !== formState.confirm_password) {
            setError('Password confirmation does not match.');
            return;
        }
        const payload = {
            first_name: formState.first_name,
            last_name: formState.last_name,
            email: formState.email,
            username: formState.username,
        };
        if (formState.password) {
            payload.password = formState.password;
            payload.confirm_password = formState.confirm_password;
        }
        try {
            await handleProfileEdit(payload);
            setEditMode(false);
        } catch (err) {
            setError(err.response?.data?.detail || 'Unable to save changes.');
        }
    };

    return (
        <section className="profile-card account-details">
            <div className="profile-card-header">
                <div>
                    <p className="profile-card-kicker">Account</p>
                    <h4>Account Details</h4>
                </div>
                {!editMode && (
                    <button
                        className="profile-icon-button"
                        type="button"
                        aria-label="Edit account details"
                        onClick={() => setEditMode(true)}
                    >
                        <i className="bi-pencil-square" />
                    </button>
                )}
            </div>
            {editMode ? (
                <div className="account-details-form">
                    <Field label="First name">
                        <input
                            className="profile-field"
                            value={formState.first_name}
                            onChange={(e) =>
                                handleChange('first_name', e.target.value)
                            }
                        />
                    </Field>
                    <Field label="Last name">
                        <input
                            className="profile-field"
                            value={formState.last_name}
                            onChange={(e) =>
                                handleChange('last_name', e.target.value)
                            }
                        />
                    </Field>
                    <Field label="Email">
                        <input
                            className="profile-field"
                            type="email"
                            value={formState.email}
                            onChange={(e) =>
                                handleChange('email', e.target.value)
                            }
                        />
                    </Field>
                    <Field label="Username">
                        <input
                            className="profile-field"
                            value={formState.username}
                            onChange={(e) =>
                                handleChange('username', e.target.value)
                            }
                        />
                    </Field>
                    <Field label="New password">
                        <input
                            className="profile-field"
                            type="password"
                            value={formState.password}
                            onChange={(e) =>
                                handleChange('password', e.target.value)
                            }
                            placeholder="Leave blank to keep current password"
                        />
                    </Field>
                    <Field label="Confirm password">
                        <input
                            className="profile-field"
                            type="password"
                            value={formState.confirm_password}
                            onChange={(e) =>
                                handleChange(
                                    'confirm_password',
                                    e.target.value
                                )
                            }
                            placeholder="Confirm new password"
                        />
                    </Field>
                    <div className="profile-action-row account-details-actions">
                        <button
                            className="btn profile-secondary-button"
                            type="button"
                            onClick={handleCancel}
                        >
                            Cancel
                        </button>
                        <button
                            className="btn profile-primary-button"
                            type="button"
                            onClick={handleSave}
                        >
                            Save
                        </button>
                    </div>
                </div>
            ) : (
                <div className="profile-info-list">
                    <div className="profile-info-row">
                        <span>Name</span>
                        <strong>
                            {[userData.first_name, userData.last_name]
                                .filter(Boolean)
                                .join(' ') || 'Not added'}
                        </strong>
                    </div>
                    <div className="profile-info-row">
                        <span>Email</span>
                        <strong>{userData.email || 'Not added'}</strong>
                    </div>
                    <div className="profile-info-row">
                        <span>Username</span>
                        <strong>{userData.username || 'Not added'}</strong>
                    </div>
                </div>
            )}
            {error && <p className="profile-inline-error">{error}</p>}
        </section>
    );
};

export default AccountDetails;
